import { Component, inject, LOCALE_ID, OnInit, signal } from '@angular/core';
import { NotificationService } from '../../../services/notifications/notifications.service';
import { NotificationType } from '../header/header.model';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-admin-notifications-component',
  imports: [],
  templateUrl: './admin-notifications-component.html',
  styleUrl: './admin-notifications-component.scss',
})
export class AdminNotificationsComponent implements OnInit {
  private notificationService = inject(NotificationService);
  private locale = inject(LOCALE_ID);
  notifications = signal<NotificationType[]>([]);
  errorLoadingNotifications = signal<boolean>(false);
  loadingNotifications = signal<boolean>(true);

  // pagination
  pageOffset = signal<number>(0);
  pageSize = signal<number>(10);
  totalPages = signal<number>(0);

  ngOnInit(): void {
    this.loadNotifications();
  }

  loadNotifications() {
    this.loadingNotifications.set(true);
    this.notificationService
      .getAllNotifications({ pageOffset: this.pageOffset(), pageSize: this.pageSize() })
      .pipe(
        finalize(() => {
          this.loadingNotifications.set(false);
        }),
      )
      .subscribe({
        next: (res) => {
          this.notifications.set(res.list);
        },
        error: (err) => {
          this.errorLoadingNotifications.set(true);
        },
      });
  }

  nextPage() {
    if (this.pageOffset() + 1 < this.totalPages()) {
      this.pageOffset.update((v) => v + 1);
      this.loadNotifications();
    }
  }

  prevPage() {
    if (this.pageOffset() > 0) {
      this.pageOffset.update((v) => v - 1);
      this.loadNotifications();
    }
  }

  markAsRead(notificationId: number) {
    const notification = this.notifications().find((n) => n.id === notificationId);
    if (notification && notification.isRead) {
      return;
    }
    this.notificationService.markNotificationAsRead(notificationId).subscribe({
      next: () => {
        if (notification && !notification.isRead) {
          notification.isRead = true;
          this.notifications.set([...this.notifications()]);
        }
      },
      error: () => {},
    });
  }

  isArabic() {
    return this.locale.startsWith('ar');
  }
  isEnglish() {
    return this.locale.startsWith('en');
  }
}
